// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10b6y","right":"styles_right__HF6WB"};